import cc from "classcat";
import Section from "./Section";

const FullWidthSection = ({
  bgColor = null,
  className = "",
  containerClassName = "",
  smallContainer = false,
  children,
  ...props
}) => (
  <div
    className={cc([
      "section section-full-width",
      {
        [`bg-${bgColor}`]: bgColor !== null,
      },
      className,
    ])}
    {...props}
  >
    <Section smallContainer={smallContainer} className={containerClassName}>
      {children}
    </Section>
  </div>
);

export default FullWidthSection;
